<template>
  <v-container grid-list-md fluid>
    <v-layout align-center justify-space-around wrap>
      <v-flex md12>

        <template v-slot:activator="{ on }">
          <v-btn
            small
            v-on="on"
            color="primary"
          >
            Upstream
          </v-btn>
        </template>

        <v-toolbar color="primary" dark dense>
          <v-toolbar-title>Upstream</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-layout wrap>
          <v-flex md8>
            <v-card>
              <v-card-title>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                  clearable
                ></v-text-field>
              </v-card-title>

              <v-data-table
                :headers="headers"
                :footer-props="{
                  'items-per-page-options': [15, 50, -1]
                }"
                :items="Object.values(allUpstream)"
                :loading="isLoading.upstream"
                :search="search"
                :sort-by="'name'"
                :sort-desc="false"
                item-key="name"
                class="elevation-1"
                dense
              >
                <template v-slot:body="{ items }">
                  <tbody>
                    <tr v-for="item in items" :key="item.name">
                      <td><v-icon small>unarchive</v-icon></td>
                      <td >{{ item.name }}</td>
                      <td >{{ item.etag }}</td>
                      <td >{{ prettyBytes(item.size) }}</td>
                      <td>{{ dateToString(item.lastmodified) }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>

          <v-flex md4>
            <v-card v-if="aaaaccess(user)">
              <!-- <v-card-title>Info</v-card-title> -->
              <v-card-text>
                <p>
                  Upstream images can be uploaded on Google Storage at
                    <a :href="'https://console.cloud.google.com/storage/browser/'+getBucketName()+'/upstream/'" target="_blank">gs://{{getBucketName()}}/upstream</a> <br />
                </p>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import libvue from '@/lib/vue.js'

export default {
  mixins: [libvue],
  data () {
    return {
      search: null,
      snack: false,
      snackColor: 'primary',
      snackMessage: '',
      snackTimeout: 1000,
      headers: [
        { text: '', value: '' },
        { text: 'Name', value: 'name' },
        { text: 'ETag', value: 'etag' },
        { text: 'Size', value: 'size' },
        { text: 'Last Modified', value: 'lastmodified' }
      ]
    }
  },
  computed: {
    ...mapGetters(['allUpstream', 'user', 'isLoading']),
  },
  created() {
    this.filterUpstream();
  },
  watch: {
  },
  methods: {
    ...mapActions(['filterUpstream'])
  }
}
</script>
